import { render } from "./LoadingAnimation.vue?vue&type=template&id=643507da"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/LoadingAnimation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "643507da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('643507da', __exports__)) {
    api.reload('643507da', __exports__)
  }
  
  module.hot.accept("./LoadingAnimation.vue?vue&type=template&id=643507da", () => {
    api.rerender('643507da', render)
  })

}


export default __exports__